import { Rule } from "antd/lib/form"
import i18n from "i18next"
import { isValidPhoneNumber } from "react-phone-number-input"
import { isNumeric, isValidBIC, isValidIBAN, isValidVAT } from "Shared/utils/helpers"
import validateEmail from "Shared/validators/email.validator"

const VendorRules = (): { [key: string]: Rule[] } => ({
    name: [
        {
            validator: (_rule: any, value: string) => {
                if (!value) {
                    return Promise.reject(i18n.t("validation:required"))
                }

                // DATEV limit
                if (value.length > 50) {
                    return Promise.reject(i18n.t("validation:string_too_long"))
                }

                return Promise.resolve()
            },
        },
    ],
    city: [
        {
            validator: (_rule: any, value: string) => {
                if (value) {
                    // DATEV limit
                    if (value.length > 30) {
                        return Promise.reject(i18n.t("validation:string_too_long"))
                    }
                }

                return Promise.resolve()
            },
        },
    ],
    creditorNumber: [
        {
            validator: (_rule: any, value: string) => {
                // DATEV limit
                if (value) {
                    if (!isNumeric(value)) {
                        return Promise.reject(i18n.t("validation:numeric"))
                    }

                    if (value.length > 0 && value.substr(0, 1) === "0") {
                        return Promise.reject(i18n.t("validation:no_leading_zero"))
                    }

                    // DATEV limit
                    if (value.length < 5) {
                        return Promise.reject(i18n.t("validation:string_too_short"))
                    }
                    if (value.length > 9) {
                        return Promise.reject(i18n.t("validation:string_too_long"))
                    }
                }

                return Promise.resolve()
            },
        },
    ],

    description: [{ required: true, message: i18n.t("validation:required"), validateTrigger: "blur" }],
    rating: [{ type: "integer", required: true, message: i18n.t("validation:required"), validateTrigger: "blur" }],
    recommendation: [{ type: "integer", required: true, message: i18n.t("validation:required"), validateTrigger: "blur" }],
    contactPersonEmail: [
        {
            validator: (_rule: any, value: string) => {
                if (!validateEmail(value) && value) {
                    return Promise.reject(new Error(i18n.t("validation:email")))
                }

                return Promise.resolve()
            },
        },
    ],
    contactPersonPhone: [
        {
            validator: (_rule: any, value: string) => {
                if (!isValidPhoneNumber(value) && value) {
                    return Promise.reject(new Error(i18n.t("validation:phone")))
                }
                return Promise.resolve()
            },
        },
    ],
    iban: [
        {
            validator: (_rule: any, value: string) => {
                if (value && value !== "" && !isValidIBAN(value)) {
                    return Promise.reject(new Error(i18n.t("validation:iban")))
                }

                return Promise.resolve()
            },
        },
    ],
    bic: [
        {
            validator: (_rule: any, value: string) => {
                if (value && value !== "" && !isValidBIC(value)) {
                    return Promise.reject(new Error(i18n.t("validation:bic")))
                }

                return Promise.resolve()
            },
        },
    ],
    vatNumber: [
        {
            validator: (_rule: any, value: string) => {
                if (value && value !== "" && !isValidVAT(value)) {
                    return Promise.reject(new Error(i18n.t("validation:vat")))
                }

                return Promise.resolve()
            },
        },
    ],
})

export default VendorRules
